import type { ReactNode } from 'react';
import { Collapsible } from 'radix-ui';
import { ChevronRight } from 'lucide-react';

export interface DisclosureProps {
  label: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Versteckt Fortgeschrittenes hinter einem Chevron. Pflichtfelder gehören nie hinein.
 * Auf Touch-Geräten ist die Zeile 44 px hoch (README „Mobil“, Ziel 44 px).
 */
export function Disclosure({ label, defaultOpen = false, children, className }: DisclosureProps) {
  return (
    <Collapsible.Root defaultOpen={defaultOpen} className={className}>
      <Collapsible.Trigger className="group inline-flex cursor-pointer items-center gap-1.5 py-1 text-sm font-medium text-foreground touch:min-h-11">
        <ChevronRight
          size={16}
          strokeWidth={1.75}
          aria-hidden
          className="text-muted-foreground transition-transform duration-150 group-data-[state=open]:rotate-90"
        />
        {label}
      </Collapsible.Trigger>
      <Collapsible.Content className="pt-3">{children}</Collapsible.Content>
    </Collapsible.Root>
  );
}
